import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
type Testimonial = {
  name: string;
  city: string;
  quote: string;
  avatar: string;
  borderColor: string;
};
const testimonials: Testimonial[] = [{
  name: 'Carlos Mendoza',
  city: 'Miami',
  quote: '"Por fin alguien cuenta lo que vivimos en venezuela. Es excelente"',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/male/45.jpg',
  borderColor: 'rgba(207, 155, 46, 0.7)'
}, {
  name: 'Elena Rodríguez',
  city: 'Madrid',
  quote: '"Un relato que te eriza la piel. Es la verdad que todos los venezolanos necesitamos que el mundo lea."',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/female/2.jpg',
  borderColor: 'rgba(207, 155, 46, 0.7)'
}, {
  name: 'Ricardo Valero',
  city: 'Bogotá',
  quote: '"Increíble análisis. Este libro es un pecado no tenerlo. Es historia pura."',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/male/22.jpg',
  borderColor: 'rgba(207, 155, 46, 0.7)'
}, {
  name: 'Javier López',
  city: 'Analista Político, Madrid',
  quote: '"No soy venezolano, pero este libro me abrió los ojos sobre cómo las potencias operan en la sombra. Fascinante y aterrador a la vez."',
  avatar: 'https://xsgames.co/randomusers/assets/avatars/male/7.jpg',
  borderColor: 'rgba(207, 155, 46, 0.7)'
}];
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#0a0a0a] py-14 md:py-28 px-6" data-id="element-199">
      <div className="max-w-5xl mx-auto" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-201">
          <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold mb-4 font-['Lato']" data-id="element-202">
            Lo que dicen los lectores
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-6" data-id="element-203">
            Voces que lo leyeron
          </h2>
          <div className="gold-divider" data-id="element-204" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-205">
          {testimonials.map((t, index) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: 0.1 + index * 0.15
        }} className="bg-[#111111] border border-[#1e1e1e] p-8 rounded-sm relative" data-id="element-206">
              <QuoteIcon className="w-8 h-8 text-[#CF9B2E]/30 absolute top-6 right-6" data-id="element-207" />

              {/* Header: Avatar + Name/City */}
              <div className="flex items-center gap-4 mb-5" data-id="element-208">
                <img src={t.avatar} alt={`Foto de ${t.name}`} loading="lazy" className="rounded-full object-cover flex-shrink-0" style={{
              width: '56px',
              height: '56px',
              border: `2px solid ${t.borderColor}`,
              boxShadow: '0 0 0 1px rgba(207, 155, 46, 0.15)'
            }} data-id="element-209" />
                <div className="min-w-0" data-id="element-210">
                  <p className="text-[#F5F0E8] font-bold text-base truncate" data-id="element-211">
                    {t.name}
                  </p>
                  <p className="text-[#9A9080] text-xs font-['Lato']" data-id="element-212">
                    {t.city}
                  </p>
                </div>
              </div>

              {/* Star rating */}
              <div className="flex gap-1 mb-4" data-id="element-213">
                <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-214" />
                <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-215" />
                <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-216" />
                <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-217" />
                <StarIcon className="w-4 h-4 fill-[#CF9B2E] text-[#CF9B2E]" data-id="element-218" />
              </div>

              {/* Quote */}
              <p className="text-[#E8D5B0] leading-relaxed text-lg" style={{
            fontFamily: 'Playfair Display, serif',
            fontStyle: 'italic'
          }} data-id="element-219">
                {t.quote}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}